<template>
  <div class="VdMenu">

    <div class="w3-container" style="padding:32px">
      <h2>This is Home</h2>
      <p>W3.CSS is a modern CSS framework with built-in responsiveness:</p>
    </div>

    <div class="w3-container" style="padding:32px">
      <h2>This is Home</h2>
      <p>W3.CSS is a modern CSS framework with built-in responsiveness:</p>

      <ul class="w3-leftbar w3-theme-border" style="list-style:none">
        <li>Smaller and faster than other CSS frameworks.</li>
        <li>Easier to learn, and easier to use than other CSS frameworks.</li>
        <li>Uses standard CSS only (No jQuery or JavaScript library).</li>
        <li>Speeds up mobile HTML apps.</li>
        <li>Provides CSS equality for all devices. PC, laptop, tablet, and mobile:</li>
      </ul>
      <br>

      <hr>
      <h2>W3.CSS is Free</h2>
      <p>W3.CSS is free to use. No license is necessary.</p>

      <hr>
      <h2>Easy to Use</h2>
      <div class="w3-container w3-sand w3-leftbar">
        <p><i>Make it as simple as possible, but not simpler.</i><br>
          Albert Einstein</p>
      </div>

      <hr>
      <h2>W3.CSS Web Site Templates</h2>

      <p>We have created some responsive W3CSS templates for you to use.</p>
      <p>You are free to modify, save, share, use or do whatever you want with them:</p>



    </div>
  </div>
</template>
<script>
import fetchClient from '@/fetchClient';
import XuLy from '@/XuLy';
export default {
  name: '',
  components: {
  },
  data() {
    return {
      msg: 'Hello world'
    }
  },
  mounted() {
    //this.GetWeather();
  },
  methods: {
    async GetWeather() {
      return await fetchClient.get(`/api/First/GetAll1`)
        .then(res => {
          this.msg = res.data.ds;
        })
        .catch(err => {
          XuLy.XuLyErr(err);
        })
    }
  }
}
</script>